module.exports = "/images/laser tag.svg?8c8e14afcc849e828111cc0ffc1345ec";